/*
 * Authors: mariushirjanu
 * Created: 24/08/2022
 */
import { Component, Input, OnInit, OnChanges, SimpleChanges, ViewChild, ElementRef, ViewEncapsulation } from '@angular/core';
import { BreakpointsService } from '../services/breakpoints.service';
import { IObject } from '../../../type_definitions/datatypes';

/**
 * @ngdoc component
 * @name ga2.common.components.component:slick
 *
 * @description
 * A directive for the slick slideshow.
 * Our version will contain 2 slideshows. 1 as the main slideshow and 1 for the navigation.
 */

@Component({
  selector: 'slick',
  template: `
    <div class="slick clearfix" [ngClass]="{'no-thumbs': !thumbsVisible}">
      <div #slickMain class="slick-main">
        <div class="slide" *ngFor="let image of images; trackById">
          <img [attr.data-lazy]="image" alt=""/>
        </div>
      </div>
      <div #slickThumbs class="slick-thumbs">
        <div class="slide" *ngFor="let thumb of thumbs; trackById">
          <img [src]="thumb" alt=""/>
        </div>
      </div>
    </div>
  `,
  styleUrls: ['./slick.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SlickComponent implements OnInit, OnChanges {
  @ViewChild('slickMain', { static: true }) public slickMain:ElementRef<HTMLElement>;
  @ViewChild('slickThumbs', { static: true }) public slickThumbs:ElementRef<HTMLElement>;

  @Input() public images:string[]; // variable (array) containing the images for our slideshow
  @Input() public thumbs:string[];
  public slickOptions:IObject;
  public thumbsVisible:boolean;

  constructor(
    private breakpointsService:BreakpointsService
  ) {
    /***/
  }

  public ngOnInit():void {
    this.slickOptions = {
      lazyLoad: this.images
    };
  }

  public ngOnChanges(changesObj:SimpleChanges):void {
    if (changesObj.images) {
      this.images = changesObj.images.currentValue;
    }
    if (changesObj.thumbs) {
      this.thumbs = changesObj.thumbs.currentValue;
      this.thumbsVisible = this.thumbs?.length > 1;
    }
    this.initSlick();
  }

  private initSlick:Function = () => {
    setTimeout((() => {
      $(this.slickMain.nativeElement).slick(this.slickConfig.main);
    }), 0);

    setTimeout((() => {
      $(this.slickThumbs.nativeElement).slick(this.slickConfig.thumbs);
    }), 600);
  };

  private get slickConfig():IObject {
    return {
      main: {
        arrows: false,
        asNavFor: '.slick-thumbs',
        draggable: false,
        fade: true,
        infinite: false,
        lazyLoad: 'ondemand'
      },
      thumbs: {
        asNavFor: '.slick-main',
        draggable: false,
        focusOnSelect: true,
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        vertical: true,
        responsive: [
          {
            breakpoint: this.breakpointsService.getBreakpoint('sm'),
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
              vertical: false
            }
          }
        ]
      }
    };
  }
}